// Feriados legales de Chile 2026 (fuente: feriados oficiales / Ley 2977 y leyes especiales).
// Pre-cargados para el MVP. En producción esto vendría del backend o una API de feriados.
//
// `irrenunciable` marca los feriados donde el comercio no puede operar (dato informativo).
export interface Holiday {
  date: string; // YYYY-MM-DD
  name: string;
  irrenunciable?: boolean;
}

export const HOLIDAYS_CL_2026: Holiday[] = [
  { date: '2026-01-01', name: 'Año Nuevo', irrenunciable: true },
  { date: '2026-04-03', name: 'Viernes Santo' },
  { date: '2026-04-04', name: 'Sábado Santo' },
  { date: '2026-05-01', name: 'Día del Trabajo', irrenunciable: true },
  { date: '2026-05-21', name: 'Día de las Glorias Navales' },
  { date: '2026-06-21', name: 'Día Nacional de los Pueblos Indígenas' },
  { date: '2026-06-29', name: 'San Pedro y San Pablo' },
  { date: '2026-07-16', name: 'Día de la Virgen del Carmen' },
  { date: '2026-08-15', name: 'Asunción de la Virgen' },
  { date: '2026-09-18', name: 'Independencia Nacional', irrenunciable: true },
  { date: '2026-09-19', name: 'Día de las Glorias del Ejército', irrenunciable: true },
  { date: '2026-10-12', name: 'Encuentro de Dos Mundos' },
  { date: '2026-10-31', name: 'Día de las Iglesias Evangélicas y Protestantes' },
  { date: '2026-11-01', name: 'Día de Todos los Santos' },
  { date: '2026-12-08', name: 'Inmaculada Concepción' },
  { date: '2026-12-25', name: 'Navidad', irrenunciable: true },
];

// Índice rápido fecha → feriado.
export const HOLIDAY_BY_DATE: Record<string, Holiday> = Object.fromEntries(
  HOLIDAYS_CL_2026.map((h) => [h.date, h])
);
